import React from 'react';
import TrustLayout from './TrustLayout';
import { PRODUCT_NAME } from '../../config/appBranding';

const LAST_UPDATED = 'April 2026';

export default function TermsPage() {
  return (
    <TrustLayout title="Terms of Service" eyebrow="Trust" lastUpdated={LAST_UPDATED}>
      <p>
        These terms govern your use of {PRODUCT_NAME} ("the Service"). By signing in, you agree to them. A formal master services agreement is available for enterprise customers &mdash; email{' '}
        <a href="mailto:sales@vizionops.com">sales@vizionops.com</a> to request one.
      </p>

      <h2>1. Your account</h2>
      <p>
        Your organization provisions accounts for authorized users. You are responsible for keeping your password confidential and for activity that occurs under your account. Notify us at{' '}
        <a href="mailto:security@vizionops.com">security@vizionops.com</a> if you suspect unauthorized access.
      </p>

      <h2>2. Acceptable use</h2>
      <p>
        You agree not to: (a) attempt to probe, scan, or test the vulnerability of the Service without authorization; (b) upload malware or data you do not have the right to share; (c) use the Service to violate applicable law; (d) interfere with other customers' use of the Service.
      </p>

      <h2>3. Your data</h2>
      <p>
        You own the data you put into the Service. We process it on your behalf to operate the product and provide support. See our <a href="/privacy">Privacy page</a> for details.
      </p>

      <h2>4. Availability</h2>
      <p>
        We strive for high availability but do not yet offer a written uptime SLA. Enterprise customers can request one as part of a commercial agreement. Scheduled maintenance is announced on the <a href="/status">Status page</a>.
      </p>

      <h2>5. Changes to the Service</h2>
      <p>
        We will add features, fix bugs, and occasionally change how things work. We will give reasonable notice of material changes that affect how you use the product.
      </p>

      <h2>6. Termination</h2>
      <p>
        You can stop using the Service at any time. On request we will export your data and delete it within 30 days. We reserve the right to suspend accounts that violate these terms or put other customers at risk, with notice where practical.
      </p>

      <h2>7. Warranty disclaimer</h2>
      <p>
        The Service is provided "as is" without warranties of any kind, express or implied, except where prohibited by law. We do not warrant that the Service will be uninterrupted or error-free.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, neither party will be liable for indirect, incidental, or consequential damages. Our aggregate liability is limited to the amount you paid for the Service in the twelve months preceding the claim.
      </p>

      <h2>9. Changes to these terms</h2>
      <p>
        We may update these terms. If the change is material we will notify account administrators by email before it takes effect. Continued use after the effective date constitutes acceptance.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions? Email <a href="mailto:hello@vizionops.com">hello@vizionops.com</a>.
      </p>
    </TrustLayout>
  );
}
